"use client";

import { c as _c } from "react/compiler-runtime";
import { SverigeTeaserCard, SverigeTeaserCards } from "~/components/job-board/subclients/sverige/teaserbar-eon-sverige";
import { useLanguage } from "~/translations/loader/use-language";

// Job page variant: the three board teasers plus a link back to the jobboard
export default function TeaserBarJobpageEonSverige() {
  const $ = _c(8);
  const t = useLanguage();
  let t0;
  if ($[0] !== t.teaserbar_header) {
    t0 = <div className="flex w-full items-baseline justify-between"><h2 className="w-full pb-6 font-bold text-4xl text-primary md:text-right lg:pb-10 lg:text-5xl" data-source="lc">{t.teaserbar_header}</h2></div>;
    $[0] = t.teaserbar_header;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SverigeTeaserCards />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t.basic_jobAd_back_button) {
    t2 = <ul className="grid grid-cols-2 gap-4 gap-y-8 md:gap-x-8 lg:grid-cols-4">{t1}<SverigeTeaserCard hideLinkText={true} href="/sverige" imageSrc="images/teaserbar/sverige/teaser4.webp" title={t.basic_jobAd_back_button} /></ul>;
    $[3] = t.basic_jobAd_back_button;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t2) {
    t3 = <section className="outer-container flex flex-col bg-card py-container"><div className="inner-container">{t0}{t2}</div></section>;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}